/// <amd-module name="Run/Extensions/Components/Timeline" />
import * as React from "react";

import { Build } from "Build/Client/Contracts/Build";
import {
    ITimelineProps,
    Timeline,
} from "Build/Shared/Components/Timeline/index";

const TimelineWithBuild = Timeline as new (props: ITimelineProps<Build>) => Timeline<Build>;

interface IRunTimelineProps {
    build: Build;
    projectId: string;
}

export const Region = "buildSummaryTimeline";

export function RunTimeline(props: IRunTimelineProps) {
    return <TimelineWithBuild
        resource={props.build}
        className="flex"
        projectId={props.projectId}
        regionForSnapshots={Region}
        showAllContributedItemsAtOnce={true}
    />
}